import Image from "next/image";
import { PropTypes } from "prop-types";

export default function ErrorToast({ message }) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-[10px]">
        <div
          className="bg-[#EF393F] rounded-[10px] flex items-center justify-center"
          style={{
            maxWidth: "33px",
            maxHeight: "33px",
            minWidth: "33px",
            minHeight: "33px",
            marginRight: "10px",
          }}
        >
          <Image
            src="/assets/icons/toast-error-icon.svg"
            alt="delete-btn"
            width={26}
            height={26}
          />
        </div>
        <div className="text-[1rem] text-[#EF393F] font-bold">{message}</div>
      </div>

      <div
        style={{
          maxWidth: "19px",
          maxHeight: "19px",
          minWidth: "19px",
          minHeight: "19px",
        }}
        className="cursor-pointer"
      >
        <Image
          src="/assets/icons/toast-delete.svg"
          alt="delete-btn"
          width={19}
          height={19}
        />
      </div>
    </div>
  );
}

ErrorToast.propTypes = {
  message: PropTypes.string,
};
